'use strict';

class OemUserConfirmService {
  constructor($resource) {
    'ngInject';

    this.api = $resource(
      '/auth_api/oem_user_confirm/:token',
      { token: '@token' },
      {
        update: { method: 'PUT', isArray: false }
      }
    )
  }
}

export default angular.module('leptonApp.OemUserConfirmService', ['ngResource'])
  .service('OemUserConfirmService', ['$resource', OemUserConfirmService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/oem_user_confirm/oem_user_confirm.service.js